import { render } from "./DebugSettings.vue?vue&type=template&id=70f4e34d"
import script from "./DebugSettings.vue?vue&type=script&lang=js"
export * from "./DebugSettings.vue?vue&type=script&lang=js"
script.render = render

export default script